import { Injectable } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {select, Store} from '@ngrx/store';
import {combineLatest, EMPTY, from, merge, of} from 'rxjs';
import {
	catchError,
	map,
	mergeMap,
	retry,
	sampleTime,
	tap,
	throttleTime, withLatestFrom
} from 'rxjs/operators';
import {CourseDataService} from '../../services/course-data.service';
import {State} from '../index';
import * as actions from './actions';
import {getCurrentCourse} from './selectors';
import {setCurrentCourse} from "./actions";
import {Router} from "@angular/router";

@Injectable()
export class CourseEffects {

	//TODO with current course retrieval, do we still need two calls?
	getCourses$ = createEffect(() => this.actions$.pipe(
		ofType(actions.courseListRequested),
		mergeMap(action =>
			this.courseData.getCourses().pipe(
				retry(2),
			)
			.pipe(
				tap(success => { }),
				map(result => actions.courseListReceived({courses: result})),
				catchError(() => EMPTY) //of(courseActions.userLoginError({message: 'An error occurred during login.'})))
			))
		)
	);

	mapMostRecentToSetCurrent = createEffect(() => combineLatest([
		this.actions$.pipe(ofType(actions.setNeedsMostRecentCourse)),
		this.actions$.pipe(ofType(actions.courseListReceived))
	]).pipe(
		map(([_, courseActions]) => {
			if (courseActions.courses.length) {
				const orderedCourses = [...courseActions.courses];
				orderedCourses.sort((a, b) => {
					const dateA = a.publication_date ? new Date(a.publication_date) : new Date('1844-01-01');
					const dateB = b.publication_date ? new Date(b.publication_date) : new Date('1844-01-01');

					return dateB.getTime() - dateA.getTime();
				});
				this.router.navigateByUrl('/s/' + orderedCourses[0].url_slug);
			}
		})
	), {dispatch: false});

	mapCurrentItemToGetDetails = createEffect(() => combineLatest(
			this.actions$.pipe(ofType(actions.setCurrentCourse)),
			this.actions$.pipe(ofType(actions.courseListReceived))
		).pipe(

		// concatMap(action => of(action).pipe(
		// 	withLatestFrom(this.store.pipe(select(selectCourseSlugsToCodeName), filter(s => !!s.length), take(1)))
		// )),
		// tap(d => console.log('merged', d)),
		withLatestFrom(this.store),
		map(([[curAction, listAction], state]) => {
			const match = listAction.courses && listAction.courses.find(c => c.url_slug === curAction.currentCourse);

			if (match) {
				// return the action to pull the course details
				return actions.getCourseDetails({courseCodename: match.system_codename, courseSlug: match.url_slug});
			}

			return actions.trash();
			// courseActions.getCourseDetails({courseId: listAction.find().currentCourse})
		})
	));

	getCourseDetails = createEffect(() => this.actions$.pipe(
		ofType(actions.getCourseDetails),
		withLatestFrom(this.store),
		mergeMap(([action, store]) => {
			//if we already have details, skip the remainder of the checks
			if (store.course.courseDetails[action.courseSlug]) return of(actions.trash());

			return this.courseData.getCourse(action.courseCodename).pipe(
				// tap(r => console.log('Returned Course Details Object:', r)),
				map(c => actions.setCourseDetails({course: c}),
					catchError(() => EMPTY) //of(courseActions.userLoginError({message: 'An error occurred during login.'})))
				)
			);

		})
	));

	markLectureOpenEvent = createEffect(() => this.actions$.pipe(
		ofType(actions.setCurrentLessonItem),
		withLatestFrom(this.store),
		tap(([action, store]) => {
			//if not a lecture or qa, bail
			if (!['lecture', 'qa'].includes(action.itemType)) return;

			const course = getCurrentCourse(store.course);
			if (course) {
			}
		})
	), {dispatch: false});

	constructor(
		private actions$: Actions,
		private store: Store<State>,
		private courseData: CourseDataService,
		private router: Router
	) {

	}
}
